import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RawTextComponent } from './raw-text.component'
import { FloCssClassSanitizePipeModule } from '../_pipes/css-class-sanitize/css-class-sanitize.pipe.module'

@NgModule({
  declarations: [RawTextComponent],
  exports: [RawTextComponent],
  imports: [CommonModule, FloCssClassSanitizePipeModule]
})
export class RawTextModule {}
